import { render, staticRenderFns } from "./EditBusinessPrivacyPolicy.vue?vue&type=template&id=8c7e379e&scoped=true&"
import script from "./EditBusinessPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./EditBusinessPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./EditBusinessPrivacyPolicy.vue?vue&type=style&index=0&id=8c7e379e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7e379e",
  null
  
)

export default component.exports